// "Seen" bookkeeping for the Reminders & Notifications red dot (#437).
//
// The card: the dot on the sidebar entry appears only while there are
// notifications the user has not yet seen, and clears the moment they open the
// feature. "Seen" is therefore a per-ITEM fact (a notification that arrives
// after the user looked must light the dot again), kept as the set of feed-item
// keys the user has had on screen.
//
// Kept in localStorage — per browser, no schema change. Replacing the stored set
// with the CURRENT feed on every "mark seen" keeps it bounded: an item that has
// left the feed (dismissed, answered, past) can never come back, so forgetting
// it costs nothing.
export const SEEN_STORAGE_KEY = 'omnis:seen-notifications';

/** Stable identity of a Bell feed item: rows and calendar events share ids. */
export const notificationKey = (item) => `${item?.type || 'reminder'}-${item?.id}`;

export function readSeen() {
    try {
        const raw = JSON.parse(localStorage.getItem(SEEN_STORAGE_KEY) || '[]');
        return new Set(Array.isArray(raw) ? raw : []);
    } catch {
        return new Set();
    }
}

export function writeSeen(items) {
    try {
        localStorage.setItem(SEEN_STORAGE_KEY, JSON.stringify((items || []).map(notificationKey)));
    } catch { /* private mode / quota — the dot simply stays until next time */ }
}

export function countUnseen(items, seen = readSeen()) {
    return (items || []).filter((it) => !seen.has(notificationKey(it))).length;
}
